export const ssItems = {
  FILTERS: 'filters',
};

export const clearFilters = () =>
  sessionStorage.setItem(ssItems.FILTERS, JSON.stringify({}));
